import moment from "moment";

export const PROFILE_STATE = {
  // app reducer >>>
  id: null,
  f_name: null,
  l_name: null,
  cellphone: null,
  email: null,
  sheba_number: null,
  referral_code: null,
  avatar: null,
  sheba_id: null,
  sheba_full_name: null,
  referrer_amount: "",
  referral_amount: "",
  referrer_atleast_transactions_amount: "",
  organization: false,
  organization_path: "",
  province_name: "",
  residence_name_province: "",
  referrer_id: "",
  city_name: "",
  sex: "",
  birthday: "",
  national_code_verification: false,
  national_id_real: "",
  referrer_type: "",
  referrer_f_name: "",
  referrer_l_name: "",
  city_latitude: null,
  city_longitude: null,
};

export const TOAST_MODAL = {
  // app reducer >>>
  show: false,
  title: "",
  body: "",
  messageType: null,
  duration: 3000,
};

export const MAIN_PAGE_STATE = {
  app_banners: [],
  top_subcats: [],
  navigators_list: [],
};
// >>>

export const BUSINESS_TRANSACTION_STATE = {
  // bussiness reducer >>>
  current_page: 1,
  next_page_url: null,
  total: 0,
  data: [],
  per_page: 10,
};

export const BUSINESS_COMMENTS_STATE = {
  // bussiness reducer
  current_page: 1,
  next_page_url: null,
  total: 0,
  data: [],
  per_page: 10,
};

export const BUSINESS_IMAGES_STATE = {
  // bussiness reducer
  base_url: "",
  images: [],
}; // >>>

export const CARD_TRANSACTIONS_STATE = {
  // card reducer >>>
  card_id: null,
  total: 0,
  per_page: 10,
  current_page: 1,
  next_page_url: null,
  data: [],
}; // >>>

// start states club reducer
export const PAYMENT_DATA_STATE = {
  selectedClub: {},
  paymentOptions: [],
  payment_code: "",
  transaction_id: "",
  business_detail: {},
  amount_of_transaction: 0,
  paymentResponse: {},
  payment_using_wallet_balance: 1,
  selectedPaymentOptions: [],
  confirmStep: false,
};

export const CLUB_TRANSACTIONS_STATE = {
  first_transaction_date: null,
  total: 1,
  current_page: 1,
  next_page_url: null,
  per_page: 10,
  data: [],
};

export const ORDER_DATA = {
  club_id: null,
  shop_name: "",
  business_id: null,
  status: "",
  amount: null,
  transaction_date: null,
  transaction_time: null,
  sub_category: "",
  selected_img: "",
  gateway_amount: null,
  tracking_code: "",
  wallet_amount: null,
};

// end states club reducer

export const FAVORITE_BUSINESSES_STATE = {
  // favorite reducer >>>
  current_page: 1,
  data: [],
  per_page: null,
  from: null,
  next_page_url: null,
  total: 0,
}; // >>>

export const ANNOUNCEMENT_STATE = {
  // notification reducer >>>
  id: null,
  title: "",
  description: "",
  cta: null,
  image_path: "",
};

export const NOTIFICATIONS_STATE = {
  // notification reducer
  current_page: 1,
  next_page_url: null,
  total: 0,
  data: [],
}; // >>>

export const WALLET_LOG_DETAIL_STATE = {
  // wallet reducer >>>
  type: null,
  data: [],
  last_page: null,
  per_page: null,
  from: null,
  next_page_url: null,
  total: 0,
  current_page: 1,
};

export const CREDIT_WALLET_LOG_DETAIL_STATE = {
  // wallet reducer
  data: [],
  last_page: null,
  per_page: null,
  from: null,
  next_page_url: null,
  total: 0,
  current_page: 1,
};

export const WALLET_LOG_STATE = {
  // wallet reducer
  first_transaction_date: null,
  icons_base_url: "",
  total: 1,
  current_page: 1,
  next_page_url: null,
  data: [],
};

export const TAXI_STATE = {
  // wallet reducer
  terminal_id: "",
  driverInfo: {},
  transaction_id: "",
  amount: "",
};

export const METRO_STATE = {
  // wallet reducer
  chargeType: "",
  cardNumber: "",
  singleTicketData: [],
  singleTourTypeCode: null,
  singleTourTypeText: "",
  amount: 0,
  tracking_code: "",
  singleTicketResponse: {},
}; // >>>

export const SINGLE_EWALLET_TRANSACTIONS = {
  // credit wallet reducer
  business_name: "",
  business_icon: "",
  total_ewallet_credits: null,
  total_convertable_amount: null,
  ratio_min: null,
  ewallet_credits: [],
  from: moment().subtract(3, "months").format("YYYY-MM-DD"), // two month before
  to: moment().format("YYYY-MM-DD"),
  first_transaction_date: null,
  daysFromFirstTransaction: 1,
};

export const CAMPAIGN_EWALLET_TRANSACTIONS = {
  // credit wallet reducer
  total_ewallet_credits: null,
  total_convertable_amount: null,
  ratio_min: null,
  campaign_businesses: [],
  campaign_info: null,
  campaign_banners: [],
  ewallet_credits: [],
  from: moment().subtract(3, "months").format("YYYY-MM-DD"), // two month before
  to: moment().format("YYYY-MM-DD"),
  first_transaction_date: null,
  daysFromFirstTransaction: 1,
};

// >>>
